import { z } from 'zod';
import { floatNumSchema } from '../validation';

export const weightTypeSchema = z.enum(['kg', 'ton', 'gram']);
export type WeightType = z.infer<typeof weightTypeSchema>;

export const weightSchema = z.object({
  value: floatNumSchema.min(0),
  type: weightTypeSchema,
});
export type Weight = z.infer<typeof weightSchema>;
